<template>
  <div
    class="popover-message"
    :style="{ top: top + 'px', left: left + 'px', '--arrow-left': arrowLeft + 'px' }"
    ref="popoverRef"
  >
    <div v-for="msg in messages" :key="msg">{{ msg }}</div>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue'
defineProps<{ messages: string[]; top: number; left: number; arrowLeft: number }>()
const popoverRef = ref<HTMLElement | null>(null)
// Expone la referencia del DOM para el padre
defineExpose({ popoverRef })
</script>
<style scoped>
.popover-message {
  position: fixed;
  min-width: 220px;
  max-width: 300px;
  background: #333;
  color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 12px 16px;
  z-index: 9999;
  font-size: 1rem;
  border: 1px solid #eee;
}
.popover-message:before {
  content: '';
  position: absolute;
  bottom: -10px;
  left: var(--arrow-left, 20px);
  border-width: 10px 10px 0 10px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
}
</style>
